import { useEffect } from "react";

import {
  selectConfigItem,
  selectLanguage,
} from "@/features/config/configSlice";
import { selectCurrentLocationStatus } from "@/features/location/locationSlice";
import {
  selectNavigationFrom,
  selectNavigationTo,
} from "@/features/navigation/navigationSlice.selectors";

import { useAppSelector } from "@/app/hooks";
import {
  selectCurrentBuildingID,
  selectCurrentFloorID,
  selectCurrentPoiID,
} from "@/features/cartography/cartographySlice.selectors";
import { LocationStatusTypes } from "@/features/utils/types";
import { CURRENT_USER_LOCATION_ID } from "@/libs/models";
import { updateUrl } from "@/libs/url";

export default function useURLParamsUpdater() {
  const currentBuildingID = useAppSelector(selectCurrentBuildingID);
  const currentFloorID = useAppSelector(selectCurrentFloorID);
  const currentPoiID = useAppSelector(selectCurrentPoiID);
  const navigationFrom = useAppSelector(selectNavigationFrom);
  const navigationTo = useAppSelector(selectNavigationTo);
  const currentLocationStatus = useAppSelector(selectCurrentLocationStatus);
  const lang = useAppSelector(selectLanguage);
  const lockToBuilding = useAppSelector(
    selectConfigItem("camera.lockToBuilding"),
  );
  const whiteLabel = useAppSelector(selectConfigItem("ui.whiteLabel"));

  // When current floor is set, update url
  useEffect(() => {
    updateUrl({
      buildingID: currentBuildingID || null,
      floorID: currentFloorID || null,
      lang: lang,
      lockCameraToBuilding: lockToBuilding,
      navigationFrom:
        navigationFrom !== CURRENT_USER_LOCATION_ID
          ? navigationFrom
          : currentLocationStatus === LocationStatusTypes.POSITIONING
            ? navigationFrom
            : null,
      navigationTo: navigationTo || null,
      poiID: currentPoiID || null,
      whiteLabel: whiteLabel || null,
    });
  }, [
    currentFloorID,
    currentBuildingID,
    currentPoiID,
    navigationFrom,
    navigationTo,
    lockToBuilding,
    whiteLabel,
    lang,
  ]);
}
